<template>
  <div class="photovoltaicStation">
    <el-row :gutter="common.gutter">
      <el-col :span="5">
        <!--"描述" 开始-->
        <div class="container" style="height: 784px">
          <!--"下拉菜单" 开始-->
          <table class="station">
            <tr>
              <td>
                <span class="prepend">选择电站</span>
                <el-select
                  v-model="optionsPowerStation.value"
                  placeholder="请选择"
                  style="width: 220px"
                  @change="optionsPowerStationMethods().handleChange($event)"
                >
                  <el-option
                    v-for="item in optionsPowerStation.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </td>
            </tr>
          </table>
          <!--"下拉菜单" 结束-->

          <my-divider :height="common.myDividerHeight10"></my-divider>

          <!--"逆变器列表" 开始-->
          <div class="inverters" v-if="description.inverter.show">
            <el-radio-group
              v-model="description.inverter.radio"
              size="medium"
              @change="descriptionMethods().inverter.change($event)"
            >
              <el-radio-button
                :label="item.name"
                v-for="(item, i) in description.inverter.inverters"
                :key="i"
                @click.native="inverterClick($event)"
              ></el-radio-button>
            </el-radio-group>
          </div>
          <!--"逆变器列表" 结束-->

          <my-divider :height="common.myDividerHeight10"></my-divider>

          <!--"描述" 开始-->
          <table class="description-1">
            <tr
              :key="item.name"
              v-for="item in descriptionComputed.filter((v) => {
                return v.vIf;
              })"
            >
              <template>
                <td class="name-description-1">{{ item.name }}</td>
                <td class="separator-description-1"></td>
                <td class="value-description-1">
                  {{ item.value }} {{ item.unit }}
                </td>
              </template>
            </tr>
          </table>
          <!--"描述" 结束-->

          <my-divider :height="common.myDividerHeight80"></my-divider>

          <!--"气象信息" 开始-->
          <meteorology-info></meteorology-info>
          <!--"气象信息" 结束-->
        </div>
        <!--"描述" 开始-->
      </el-col>
      <el-col :span="13">
        <!--"发电量" 开始-->
        <div class="container">
          <power-quantity :entity="quantity"></power-quantity>
        </div>
        <!--"发电量" 结束-->

        <my-divider :height="common.myDividerHeight10"></my-divider>

        <!--"图表" 开始-->
        <div class="container">
          <PhotovoltaicStationCharts :entity="echarts" />
          <!-- <power-quantity-charts :entity="echarts"></power-quantity-charts> -->
        </div>
        <!--"图表" 结束-->
      </el-col>
      <el-col :span="6">
        <!--"视频信息" 开始-->
        <div class="container" style="height: 784px">
          <div
            style="cursor: pointer"
            title="跳转监控管理"
            @click="$router.push('/photovoltaicMonitor')"
          >
            <my-title title="视频信息"></my-title>
          </div>
          <my-divider :height="common.myDividerHeight10"></my-divider>
          <template v-if="inverterIdVideo">
            <div style="width: 100%; height: 250px; display: inline-block">
              <el-image
                style="width: 100%; height: 100%"
                :src="require('@/assets/images/video/noVideo.svg')"
                fit="fill"
              ></el-image>
            </div>
          </template>
          <VideoPlayerWithPagination
            v-else
            videoId="videoPvcStation"
            :stationId="stationIdVideo"
          />
        </div>
        <!--"视频信息" 结束-->
      </el-col>
    </el-row>
    <my-divider :height="common.myDividerHeight10"></my-divider>
    <el-row v-if="optionsPowerStation.actionCurrent === 'inverter'">
      <el-col :span="24">
        <!--逆变器信息 开始-->
        <div class="container">
          <inverter-info :entity="inverter"></inverter-info>
        </div>
        <!--逆变器信息 结束-->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import MyDivider from "@/components/MyDivider";
import NameValueVerticalWithUnit from "@/components/zixitong/airSystem/NameValueVerticalWithUnit";
import Charts from "@/components/zixitong/elevatorSystem/Charts";
import MyTitle from "@/components/MyTitle";
import OmitLine from "@/components/EChartsFolder/OmitLine";
import NameValueWithDialog from "@/components/zixitong/photovoltaicSystem/NameValueWithDialog";
import api from "@/api";
import ElDatePickerWithOptions from "@/components/zixitong/photovoltaicSystem/ElDatePickerWithOptions";
import VideoPlayerWithPagination from "@/components/VideoPlayer/VideoPlayerWithPagination";
import RunningTimeCharts from "@/components/shebeiguanli/RunningTimeCharts";
import PublicEcharts from "@/components/PublicEcharts";
import PowerQuantity from "@/components/zixitong/photovoltaicSystem/PowerQuantity";
import PowerQuantityCharts from "@/components/zixitong/photovoltaicSystem/PowerQuantityCharts";
import MeteorologyInfo from "@/components/zixitong/photovoltaicSystem/MeteorologyInfo";
import InverterInfo from "@/components/zixitong/photovoltaicSystem/InverterInfo";
import PhotovoltaicStationCharts from "@/components/zixitong/photovoltaicSystem/PhotovoltaicStationCharts.vue";
export default {
  components: {
    InverterInfo,
    MeteorologyInfo,
    PowerQuantityCharts,
    PowerQuantity,
    PublicEcharts,
    RunningTimeCharts,
    ElDatePickerWithOptions,
    NameValueWithDialog,
    MyTitle,
    NameValueVerticalWithUnit,
    MyDivider,
    Charts,
    OmitLine,
    VideoPlayerWithPagination,
    PhotovoltaicStationCharts,
  },
  data() {
    return {
      common: {
        myDividerHeight10: "10px",
        myDividerHeight40: "40px",
        myDividerHeight80: "80px",

        gutter: 10,

        /**
         * @description 由光伏系统跳转过来时的参数 id，有可能是电站 id，也有可能是逆变器 id。
         * */
        paramId: undefined,
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))[
          "projects"
        ][0].projectId,
      },

      /*"分电站下拉列表" 开始*/
      optionsPowerStation: {
        /**
         * @description 电站列表
         * */
        options: [{ value: "all", label: "全部电站" }],
        value: "all",
        /**
         * @description 当前被选择的电站 id
         * */
        stationIdCurrent: "",
        /**
         * @description 当前被选择的电站名称
         * */
        stationNameCurrent: "",
        /**
         * @description 当前被选择的逆变器 id
         * */
        inverterIdCurrent: "",
        /**
         * @description 当前被选择的逆变器名称
         * */
        inverterNameCurrent: "",
        /**
         * @description 当前被选择的实体标识。
         * @description 'all' 代表当前的选择是 '全部电站'。
         * @description 'station' 代表当前的选择是 '某一个电站'。
         * @description 'inverter' 代表当前的选择是 '某一个逆变器'。
         * */
        actionCurrent: "all",
        /**
         * @description 电站、逆变器的归属关系。
         * @description 格式为 [{"inverterId":"","name":"","type":"逆变器","stationId":""}]。
         * @description inverterId：逆变器 id。
         * @description name：逆变器名称。
         * @description type：'逆变器'（固定值）。
         * @description stationId：逆变器所属的电站 id。
         * */
        stationInverterTree: [],
      },
      /*"分电站下拉列表" 结束*/

      /*"描述" 开始*/
      description: {
        inverter: {
          show: false,
          radio: "",
          inverters: [],
        },
        /**
         * @description 实体信息
         * */
        info: {},
      },
      /*"描述" 结束*/

      /**
       * @description 发电量。是个对象，格式为{id:'',type:''}。
       * @description 和子组件<power-quantity :entity="quantity"></power-quantity>绑定在一起。
       * @description id：实体 id。
       * @description type：实体类型，project/station/inverter，三取一，固定值。
       * @description project：项目（全部电站）。
       * @description station：电站。
       * @description inverter：逆变器。
       * */
      quantity: {
        id: JSON.parse(window.sessionStorage.getItem("userInfo"))["projects"][0]
          .projectId,
        type: "project",
      },

      /**
       * @description 图表。是个对象，格式为{id:'',type:'',name:''}。
       * @description 和子组件<power-quantity-charts :entity="echarts"></power-quantity-charts>绑定在一起。
       * @description id：实体 id。
       * @description type：实体类型，project/station/inverter，三取一，固定值。
       * @description name：实体名称，如果type=project,则name=全部电站。如果type=station，则name=电站名称。如果type=inverter,则name=逆变器名称。
       * @description project：项目（全部电站）。
       * @description station：电站。
       * @description inverter：逆变器。
       * */
      echarts: {
        id: JSON.parse(window.sessionStorage.getItem("userInfo"))["projects"][0]
          .projectId,
        type: "project",
        name: "",
      },

      /*"视频信息" 开始*/
      stationIdVideo: null,
      inverterIdVideo: null,
      /*"视频信息" 结束*/

      /**
       * @description 逆变器信息。是个对象，格式为{inverterId:'',inverterName:'',stationName:''}。
       * @description 和子组件<inverter-info :entity="inverter"></inverter-info>绑定在一起。
       * @description inverterId：逆变器 id。
       * @description inverterName：逆变器名称。
       * @description stationName：逆变器所属的电站名称。
       * */
      inverter: { inverterId: "", inverterName: "", stationName: "" },
    };
  },
  created() {
    this.optionsPowerStationMethods().getPvEntityInfoAll();
    this.common.paramId = this.$route.params.id; // 如果从光伏系统跳转过来，将参数 id 赋值给 paramId
  },
  methods: {
    /**
     * @description 排序。该方法返回排序后的数组，并对原数组进行了修改。
     * @param {Array} array 被排序的数组，样例：[{id:'',name:''}]。
     * @param {String} key 按哪个键排序，比如上面样例的 id 或者 name。
     * @param {Boolean} asc 升序还是降序。asc = true 升序，asc = false 降序
     * @return {Array} 返回排序后的数组
     * */
    sortByKey(array, key, asc) {
      return array.sort(function (a, b) {
        const x = a[key];
        const y = b[key];

        return asc ? (x < y ? -1 : x > y ? 1 : 0) : x > y ? -1 : x < y ? 1 : 0;
      });
    },

    /**
     * @description 逆变器的点击事件。
     * @description 主要用来处理取消选择当前逆变器的事件。
     * @param e 当前事件对象。
     * */
    inverterClick(e) {
      this.common.paramId = undefined;

      let tagName = e.target.tagName;
      if (tagName === "INPUT") {
        let value = e.target.value;
        if (value === this.optionsPowerStation.inverterNameCurrent) {
          this.description.inverter.radio = "";
          this.optionsPowerStation.inverterIdCurrent = "";
          this.optionsPowerStation.inverterNameCurrent = "";
          this.optionsPowerStation.actionCurrent = "station";

          this.quantity = {
            id: this.optionsPowerStation.stationIdCurrent,
            type: "station",
            name: this.optionsPowerStationMethods().getStationNameById(
              this.optionsPowerStation.stationIdCurrent
            ),
          };
          this.echarts = {
            id: this.optionsPowerStation.stationIdCurrent,
            type: "station",
            name: this.optionsPowerStationMethods().getStationNameById(
              this.optionsPowerStation.stationIdCurrent
            ),
          };

          this.optionsPowerStationMethods().getPvEntityInfoStation();

          this.stationIdVideo = this.optionsPowerStation.stationIdCurrent;

          this.inverterIdVideo = null;
        }
      }
    },
    /*"描述" 方法 开始*/
    descriptionMethods() {
      let that = this;
      return {
        inverter: {
          /**
           * @description 逆变器选择事件
           * @param {String} val 当前被选择的逆变器名称
           * */
          change(val) {
            let type = "inverter";
            that.common.paramId = undefined;

            that.optionsPowerStation.actionCurrent = "inverter";

            that.description.inverter.inverters.forEach((value) => {
              let id = value.id;
              let name = value.name;

              if (val === name) {
                that.quantity = { id, type };
                that.inverter = {
                  inverterId: id,
                  inverterName: name,
                  stationName: that.optionsPowerStation.stationNameCurrent,
                };
                that.echarts = { id, type, name };

                that.optionsPowerStation.inverterIdCurrent = id;
                that.optionsPowerStation.inverterNameCurrent = name;

                that.inverterIdVideo = id;
              }
            });

            that.optionsPowerStationMethods().getPvEntityInfoInverter();
          },
        },
      };
    },
    /*"描述" 方法 结束*/

    /*"分电站下拉列表"方法 开始*/
    optionsPowerStationMethods() {
      let that = this;
      return {
        /**
         * @description 根据电站 id 获取电站名称。
         * @param {String} stationId 电站 id
         * @return {String} 返回电站名称
         * */
        getStationNameById(stationId) {
          let stationName;
          that.optionsPowerStation.options.forEach((val) => {
            let id = val.value;
            let name = val.label;

            if (id === stationId) {
              stationName = name;
            }
          });

          return stationName;
        },

        /**
         * @description 电站列表选择事件。
         * @param {String} val 如果选择全部电站，则 val = 'all'。否则 val = 当前被选择电站的 id。
         * */
        handleChange(val) {
          that.common.paramId = undefined;
          that.inverterIdVideo = null;
          that.description.inverter.radio = "";

          that.description.inverter.show = val !== "all";

          if (val === "all") {
            // 选择的是 “全部电站”
            let type = "project";

            that.quantity = { id: that.common.projectId, type };
            that.echarts = {
              id: that.common.projectId,
              type,
              name: "全部电站",
            };

            that.optionsPowerStationMethods().getPvEntityInfoAll();
            that.optionsPowerStation.actionCurrent = "all";
            that.stationIdVideo = null;
          } else {
            // 选择的是 "某一个电站"
            let type = "station";

            that.quantity = { id: val, type };
            that.echarts = {
              id: val,
              type,
              name: that.optionsPowerStationMethods().getStationNameById(val),
            };

            that.optionsPowerStation.stationIdCurrent = val;
            that.optionsPowerStation.stationNameCurrent = that
              .optionsPowerStationMethods()
              .getStationNameById(val);
            that.optionsPowerStationMethods().getPvEntityInfoStation();
            that.optionsPowerStation.actionCurrent = type;

            that.stationIdVideo = val;
          }
        },

        /**
         * @description 实体信息（全部电站）
         * */
        async getPvEntityInfoAll() {
          console.log("全部电站");

          that.common.paramId = undefined; // 清除由光伏系统跳转过来时携带的参数 id

          let params = {
            projectId: that.common.projectId,
          };

          let res = await api.photovoltaicGetPvEntityInfo(params);
          if (res && res.status === 200) {
            that.optionsPowerStation.options = [];
            that.optionsPowerStation.stationInverterTree = [];

            let data = res.data.data;
            data.children.forEach((val) => {
              let stationId = val.id; // 电站 id
              let stationName = val.name; // 电站名称
              let obj = { value: stationId, label: stationName };
              that.optionsPowerStation.options.push(obj);

              api.photovoltaicGetPvEntityInfo({ stationId }).then((res) => {
                let inverterId;
                let inverterName;
                res.data.data.children.forEach((v) => {
                  inverterId = v.id; // 逆变器 id
                  inverterName = v.name; // 逆变器名称

                  // 存储到 stationInverterTree
                  that.optionsPowerStation.stationInverterTree.push({
                    inverterId: inverterId,
                    name: inverterName,
                    type: "逆变器",
                    stationId: stationId,
                  });
                });
              });
            });

            that.sortByKey(that.optionsPowerStation.options, "label", true); // 对电站列表进行排序-升序

            // 将 “全部电站” 添加到第一项
            that.optionsPowerStation.options = [
              {
                value: "all",
                label: "全部电站",
              },
              ...that.optionsPowerStation.options,
            ];

            that.description.info = data;
          }
        },

        /**
         * @description 实体信息（某个电站）
         * */
        async getPvEntityInfoStation() {
          console.log("某个电站");
          let params = { stationId: that.optionsPowerStation.stationIdCurrent };
          let res = await api.photovoltaicGetPvEntityInfo(params);
          if (res && res.status === 200) {
            let data = res.data.data;
            that.description.info = data;
            that.description.inverter.inverters = data.children;
          }
        },

        /**
         * @description 实体信息（某个逆变器）
         * */
        async getPvEntityInfoInverter() {
          console.log("某个逆变器");

          let params = {
            inverterId: that.optionsPowerStation.inverterIdCurrent,
          };
          let res = await api.photovoltaicGetPvEntityInfo(params);
          if (res && res.status === 200) {
            that.description.info = res.data.data;
          }
        },
      };
    },
    /*"分电站下拉列表"方法 结束*/
  },
  watch: {
    "optionsPowerStation.stationInverterTree": {
      handler(newVal, oldVal) {
        console.log(newVal);
        console.log(oldVal);

        let paramId = this.common.paramId;
        if (paramId !== undefined) {
          let stationId;
          let inverterId;
          this.description.inverter.show = true;

          newVal.forEach((val) => {
            stationId = val.stationId;
            inverterId = val.inverterId;

            if (paramId === stationId) {
              // 页面跳转传过来的是电站 id
              let type = "station";
              this.optionsPowerStation.value = stationId;
              this.optionsPowerStation.stationIdCurrent = stationId;
              this.optionsPowerStation.stationNameCurrent =
                this.optionsPowerStationMethods().getStationNameById(stationId);
              this.optionsPowerStationMethods().getPvEntityInfoStation();
              this.optionsPowerStation.actionCurrent = "station";

              this.stationIdVideo = stationId;

              this.inverterIdVideo = null;

              this.description.inverter.radio = "";

              this.quantity = { id: stationId, type };
              this.echarts = {
                id: stationId,
                type,
                name: this.optionsPowerStation.stationNameCurrent,
              };
            } else if (paramId === inverterId) {
              this.optionsPowerStation.actionCurrent = "inverter";
              this.optionsPowerStation.value = stationId;
              this.optionsPowerStation.stationIdCurrent = stationId;
              this.optionsPowerStation.stationNameCurrent =
                this.optionsPowerStationMethods().getStationNameById(stationId);
              this.optionsPowerStationMethods().getPvEntityInfoStation();
              this.optionsPowerStation.actionCurrent = "station";

              this.stationIdVideo = stationId;

              this.inverterIdVideo = null;

              this.description.inverter.radio = "";
            }
          });
        }
      },
    },
    "description.inverter.inverters": {
      handler(newVal, oldVal) {
        console.log(newVal);
        console.log(oldVal);

        let paramId = this.common.paramId;
        if (paramId !== undefined) {
          newVal.forEach((val) => {
            let type = "inverter";
            let inverterId = val.id;
            let inverterName = val.name;

            if (paramId === inverterId) {
              this.optionsPowerStation.actionCurrent = "inverter";

              this.optionsPowerStation.inverterIdCurrent = inverterId;
              this.optionsPowerStation.inverterNameCurrent = inverterName;

              this.inverterIdVideo = inverterId;

              this.description.inverter.radio = inverterName;

              this.optionsPowerStationMethods().getPvEntityInfoInverter();
              this.quantity = { id: inverterId, type };
              this.echarts = { id: inverterId, type, name: inverterName };
              this.inverter = {
                inverterId: inverterId,
                inverterName: inverterName,
                stationName: this.optionsPowerStation.stationNameCurrent,
              };
            }
          });
        }
      },
    },
  },
  computed: {
    /**
     * @description 实体信息描述。
     * @description 不同的实体类型显示的信息有所不同。
     * */
    descriptionComputed() {
      let actionAll = "all";
      let actionStation = "station";
      let actionInverter = "inverter";

      let unitKw = "kw";

      let info = this.description.info;
      let actionCurrent = this.optionsPowerStation.actionCurrent;

      let showAllOrStation =
        actionCurrent === actionAll || actionCurrent === actionStation; // 选择"全部电站"或"某一个电站"时显示
      let showStation = actionCurrent === actionStation; // 选择"某一个电站"时显示
      let showInverter = actionCurrent === actionInverter; // 选择"某一个逆变器"时显示

      return [
        {
          vIf: showAllOrStation,
          name: "装机功率",
          value: info.InstalledPower,
          unit: "kwp",
        },
        {
          vIf: showAllOrStation,
          name: "光伏组件数量",
          value: info["PVModuleNum"],
          unit: "",
        },
        {
          vIf: showAllOrStation,
          name: "阵列面积",
          value: info["ArrayArea"],
          unit: "㎡",
        },
        {
          vIf: showAllOrStation,
          name: "逆变器数量",
          value: info["inverterCount"],
          unit: "",
        },
        {
          vIf: showAllOrStation,
          name: "投运时间",
          value: info["OperationTime"],
          unit: "",
        },
        {
          vIf: showStation,
          name: "安装位置",
          value: info.Location,
          unit: "",
        },
        {
          vIf: showInverter,
          name: "型号",
          value: info["Model"],
          unit: "",
        },
        {
          vIf: showInverter,
          name: "额定功率",
          value: info.InstalledPower === undefined ? "-" : info.InstalledPower,
          unit: "",
        },
        // {
        //   "vIf": showInverter,
        //   "name": "日最大发电功率",
        //   "value": info["dayMaxPower"],
        //   "unit": unitKw
        // },
        // {
        //   "vIf": showInverter,
        //   "name": "月最大发电功率",
        //   "value": info["monthMaxPower"],
        //   "unit": unitKw
        // },
        // {
        //   "vIf": showInverter,
        //   "name": "年最大发电功率",
        //   "value": info["yearMaxPower"],
        //   "unit": unitKw
        // },
        {
          vIf: true,
          name: "最近巡检时间",
          value:
            info["latestInspectionTime"] === 0
              ? "-"
              : info["latestInspectionTime"],
          unit: "",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
$colorMain: #28cccb;
$borderColor: #eeeeee;

::v-deep .el-radio-group {
  .el-radio-button {
    margin-bottom: 5px;
  }
}

.el-menu {
  border-right: none;
}

td.name-description-1 {
  text-align: right;
  color: #666666;
  width: 140px;
}

td.separator-description-1 {
  width: 20px;
}

table {
  width: 100%;
}

table.description-1 {
  tr {
    height: 35px;
  }
}

.el-carouse-item-my:hover {
  cursor: pointer;
}

span.prepend {
  display: inline-block;
  padding: 10px;
}

::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
  width: 7px;
  height: 7px;
  background: transparent;
  border: 1px solid $colorMain;
  border-radius: 50%;
  opacity: 0.5;
}

::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 7px;
  height: 7px;
  background: $colorMain;
  border-radius: 50%;
  opacity: 1;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #ffffff;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  margin-right: 10px;
}

.el-select {
  margin-right: 10px;
  width: 100px;
}

div.photovoltaicStation {
  @include setPage;
}

div.container {
  background-color: #ffffff;
  padding: 10px;
  border-radius: 6px;
}
</style>
